import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import { UpperRightArrow } from "../../../shared/assets/icons";

const CampaignUpdateAggregated = () => {
  const campaigns = [
    {
      count: 856,
      label: "Completed Campaigns",
      isActive: false,
    },
    {
      count: 672,
      label: "On-Going Campaigns",
      isActive: true,
    },
    {
      count: 45624,
      label: "Upcoming Campaigns",
      isActive: false,
    },
  ];

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={2}
      // marginLeft={{ xs: "0.4rem", sm: "0.4rem" }}
      sx={{ borderRadius: "8px", height: "400px" }}
    >
      {campaigns.map((campaign, index) => (
        <Card
          key={index}
          style={{
            backgroundColor: campaign.isActive ? "#418CFF" : "#fff",
            color: campaign.isActive ? "#fff" : "#000",
            borderRadius: "12px",
            boxShadow: campaign.isActive
              ? "0px 4px 6px rgba(0, 0, 0, 0.1)"
              : "none",
            width: "100%",
            minWidth: "100px",
            position: "relative",
          }}
        >
          <CardContent
            style={{
              padding: "16px",
            }}
          >
            {/* View Icon */}
            <Typography
              variant="body2"
              style={{
                position: "absolute",
                top: "0px",
                right: "0px",
                backgroundColor: "#f7fafc",
                color: "#418CFF",
                padding: "4px 8px",
                borderRadius: "7px 0 0 7px",
                fontSize: "15px",
                fontWeight: "bold",

                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              View
              <UpperRightArrow color="var(--primary-color)" size="11" />
            </Typography>

            {/* Count and Label */}
            <Box sx={{ height: "300px", paddingTop: "16px" }}>
              <Typography
                variant="h5"
                style={{
                  fontWeight: "bold",
                  marginBottom: "4px",
                  lineHeight: "1.2",
                }}
              >
                {campaign.count}
              </Typography>
              <Typography
                variant="body2"
                style={{
                  color: campaign.isActive ? "#fff" : "#6B6B6B",
                  fontSize: "14px",
                }}
              >
                {campaign.label}
              </Typography>
            </Box>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default CampaignUpdateAggregated;
